import { selector, selectorFamily } from 'recoil';
import { ProductName } from '@zurich/api/contract';
import { createArrayByUniqueKeyHigherOrderSelectorFamily, createFieldSelectorFamily, } from '@zurich/common/recoil';
import { InsuranceCompanyCodes } from '@zurich/common/types';
import { productFeaturesSelectorFamily } from '../root';
export const productFeatureSelectorFamily = createArrayByUniqueKeyHigherOrderSelectorFamily(productFeaturesSelectorFamily, 'productfeatureType', { defaultValue: {} });
// direct selector to product option to create field selectors based off of this
export const productFeaturePFAddOnOptionsMotorSelectorFamily = selectorFamily({
    key: '@zurich/contract/PFAddOnOptionsMotor',
    get: ({ productName }) => ({ get }) => get(productFeatureSelectorFamily({
        productfeatureType: 'pF_AddOnOptionsMotor',
        productName,
    })),
    set: ({ productName }) => ({ set }, value) => {
        set(productFeatureSelectorFamily({
            productfeatureType: 'pF_AddOnOptionsMotor',
            productName,
        }), value);
    },
});
export const pfAddOnOptionsMotorHelper = createFieldSelectorFamily(productFeaturePFAddOnOptionsMotorSelectorFamily);
export const pfAddOnOptionsMotorInsuranceConfirmationNumberSelectorFamily = pfAddOnOptionsMotorHelper('insuranceConfirmationNumber', {
    defaultValue: undefined,
});
export const insuranceConfirmationNumberSelector = selector({
    key: '@zurich/products/productfeatures/insuranceConfirmationNumber',
    get: ({ get }) => {
        const value = get(pfAddOnOptionsMotorInsuranceConfirmationNumberSelectorFamily({
            productName: ProductName.NMP,
        }));
        return String(value).startsWith(InsuranceCompanyCodes.ZURICH)
            ? String(value).substring(InsuranceCompanyCodes.ZURICH.length)
            : value;
    },
    set: ({ set }, value) => {
        set(pfAddOnOptionsMotorInsuranceConfirmationNumberSelectorFamily({
            productName: ProductName.NMP,
        }), typeof value === 'string' ? `${InsuranceCompanyCodes.ZURICH}${value}` : '');
    },
});
